import { useState } from 'react';
import httpCommon from '../../http-common';

const CHANGE_PASSWORD = 'change-password';

async function submitRegisterationForm(registrationForm) {
  return fetch('../registrationform', {
    method: 'POST',
    body: JSON.stringify(registrationForm),
    headers: {
      'Content-Type': 'application/json'
    },
  })
    .then(async response => {
        console.log("response is: ", response);
        return response;
    });
}

async function register(regDetails) {
  return fetch('../auth/register', {
    method: 'POST',
    body: JSON.stringify(regDetails),
    headers: {
      'Content-Type': 'application/json'
    },
  })
    .then(async response => {
        console.log("response is: ", response);
        return response;
    });
}

async function resetRequest(emailAddress) {
  return fetch('../auth/resetrequest', {
    method: 'POST',
    body: JSON.stringify({email: emailAddress}),
    headers: {
      'Content-Type': 'application/json'
    },
  })
    .then(async response => {
        console.log("response is: ", response);
        return response;
    });
}

async function logoutUser() {
  const authObject = httpCommon.loadAuthTokenFromStorage();
  if (authObject) {
    return fetch('../auth/', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'authuser': authObject.authUser,
        'authToken': authObject.authToken,
      },
    })
      .then(async response => {
          console.log("response is: ", response);
          if (response.status === 200) {
            httpCommon.clearAuthTokenFromStorage();
          } else {
            const loginResult = {loginResult: response.body};
            throw loginResult;
          }
      });
  } else {
    //not actually logged in...
    httpCommon.clearAuthTokenFromStorage();
  }
}
async function loginUser(credentials) {
    return fetch('../auth/', {
      method: 'POST',
      body: JSON.stringify(credentials),
      headers: {
        'Content-Type': 'application/json'
      },
    })
      .then(async response => {
          console.log("response is: ", response);
          if (response.status === 200) {
            const data = await response.json();
            if (data.changePassword) {
              const loginResult = {loginResult: CHANGE_PASSWORD};
              throw loginResult;
            } else {
              console.log('yay', data);
              return data;
            }
          } else {
            const loginResult = {loginResult: response.body};
            throw loginResult;
          }
      });
}

async function changePassword(passwords) {
  //return fetch('https://txirmua64h.execute-api.eu-west-3.amazonaws.com/Prod/auth/', {
  return fetch('../auth/change', {
    method: 'POST',
    body: JSON.stringify(passwords),
    headers: {
      'Content-Type': 'application/json'
    },
  })
    .then(async response => {
        console.log("response is: ", response);
        if (response.status === 200) {
          const data = await response.json();
          return data;
        } else {
          const changePasswordResult = {loginResult: response.body};
          throw changePasswordResult;
        }
    });
}

function useToken() {
    const getToken = () => {
      const tokenString = localStorage.getItem('token');
      const userToken = JSON.parse(tokenString);
      return userToken?.token
    };
  
    const [token, setToken] = useState(getToken());
  
    const saveToken = userToken => {
      if (userToken) {
          localStorage.setItem('token', JSON.stringify(userToken));
          setToken(userToken.token);
      } else {
          localStorage.removeItem('token');
          setToken(null);
      }
    };
  
    return {
      setToken: saveToken,
      token
    }
}

async function verifyCaptchaToken(token) {
  return fetch('../auth/verifycaptcha', {
    method: 'POST',
    body: JSON.stringify({captchaToken: token }),
    headers: {
      'Content-Type': 'application/json'
    },
  })
    .then(async response => {
      const responseJson = await response.json();
      console.log("response is: ", responseJson);
      return responseJson;
    });
}

const AuthService = {
    loginUser,
    logoutUser,
    useToken,
    changePassword,
    CHANGE_PASSWORD,
    register,
    resetRequest,
    submitRegisterationForm,
    verifyCaptchaToken
  };
  
  export default AuthService;